import React from 'react'
import '../Styles/loading.scss'

export const Loading = () => {
  return (
    <div className="modern-loader">
      <div className="modern-loader-spinner" />
      <p className="modern-loader-text">Loading data...</p>
    </div>
  )
}
